import React from 'react';
import PropTypes from 'prop-types';
import { Modal, Table } from 'react-bootstrap';

export default function QualityItemsDetailModal({ show, onHide, title, items, columns }) {
  return (
    <Modal show={show} onHide={onHide} size="lg" centered scrollable>
      <Modal.Header closeButton>
        <Modal.Title style={{ fontSize: 16 }}>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {items.length === 0 ? (
          <div className="text-center text-muted py-3">No items.</div>
        ) : (
          <>
            <div className="text-muted" style={{ fontSize: 12, marginBottom: 8 }}>
              Total: <strong>{items.length}</strong> item{items.length === 1 ? '' : 's'}
            </div>
            <Table responsive size="sm" bordered>
              <thead>
                <tr>
                  <th style={{ width: 44 }}>#</th>
                  {columns.map(col => (
                    <th key={col.key}>{col.label}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {items.map((item, idx) => (
                  <tr key={`${item.jobNo}-${item.winNo}-${idx}`}>
                    <td>{idx + 1}</td>
                    {columns.map(col => (
                      <td key={col.key}>{col.render ? col.render(item) : item[col.key]}</td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </Table>
          </>
        )}
      </Modal.Body>
    </Modal>
  );
}

QualityItemsDetailModal.propTypes = {
  show: PropTypes.bool.isRequired,
  onHide: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  items: PropTypes.array.isRequired,
  columns: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      render: PropTypes.func
    })
  ).isRequired
};
